import deepmerge from "deepmerge";
import { Fancybox, Panzoom, Carousel } from "typings/Fancyapps";

export class Fancyapps
{
	public Fancybox: typeof Fancybox;
	public Panzoom: typeof Panzoom;
	public Carousel: typeof Carousel;

	private constructor(fancyappsImport)
	{
		// Set Array merge to overwrite the source array with the destination one
		const mergeOptions: deepmerge.Options = {
			arrayMerge: (destinationArray: [], sourceArray: [], options: deepmerge.Options): [] => sourceArray
		};

		const closeButtonSvg = `<svg class="svg-inline--fa" aria-hidden="true"><use xlink:href="#fa-solid-fa-xmark"></use></svg>`;
		
		fancyappsImport.Fancybox.defaults.template.closeButton = closeButtonSvg;
		fancyappsImport.Fancybox.defaults.showClass = "fancybox-fadeIn";
		fancyappsImport.Fancybox.defaults.closeButton = "inside";

		const toolbarDefaults = {
			display: ["zoom", "close"],
			items: {
				close: {
					html: closeButtonSvg
				},
				zoom: {
					html: `<svg class="svg-inline--fa" aria-hidden="true"><use xlink:href="#fa-regular-fa-magnifying-glass-plus"></use></svg>`
				}
			}
		};

		fancyappsImport.Fancybox.Plugins.Toolbar.defaults = deepmerge(fancyappsImport.Fancybox.Plugins.Toolbar.defaults, toolbarDefaults, mergeOptions);

		fancyappsImport.Fancybox.Plugins.Thumbs.defaults.autoStart = false;

		const carouselNavDefaults = {
			prevTpl: `<svg class="svg-inline--fa" aria-hidden="true"><use xlink:href="#fa-solid-fa-chevron-left"></use></svg>`,
			nextTpl: `<svg class="svg-inline--fa" aria-hidden="true"><use xlink:href="#fa-solid-fa-chevron-right"></use></svg>`
		};

		fancyappsImport.Carousel.Plugins.Navigation.defaults = deepmerge(fancyappsImport.Carousel.Plugins.Navigation.defaults, carouselNavDefaults, mergeOptions);

		this.Fancybox = fancyappsImport.Fancybox;
		this.Panzoom = fancyappsImport.Panzoom;
		this.Carousel = fancyappsImport.Carousel;
	}

	static async Import(): Promise<Fancyapps>
	{
		const FancyappsPromise = new Promise<Fancyapps>((resolve, reject) =>
		{
			import("./Imports/_Fancyapps")
				.then((fancyapps) =>
				{
					const instance = new Fancyapps(fancyapps);
					resolve(instance);
				})
				.catch((error) =>
				{
					console.log(error);
					reject("error");
				});
		});

		return FancyappsPromise;
	}
}